import { GLOBAL_API_BASE_URL, VERIFY_API_BASE_URL } from '@chk/env-variables';
import { CURRENT_SERVICE_TYPE, SERVICE_TYPE } from '@utility/checkout-utils';
import type { UseQueryParams, UseQueryResult } from '@utility/checkout-utils';
import { useQuery } from '@utility/checkout-utils';

export function useGlobalApiQuery<ResponseType>(
  queryParams: UseQueryParams
): UseQueryResult<ResponseType> {
  const baseUrl =
    CURRENT_SERVICE_TYPE === SERVICE_TYPE.AIS_DEPRECATED
      ? VERIFY_API_BASE_URL
      : GLOBAL_API_BASE_URL;

  return useQuery<ResponseType>({
    ...queryParams,
    baseUrl,
    shouldTrackException: false,
  });
}
